import { createFileRoute } from '@tanstack/react-router';

import { AuthLayout } from '@/components/layouts/AuthLayout';
import { StaffAuthBrandPanel } from '@/components/layouts/components/StaffAuthBrandPanel';
import { MFASetupForm } from '@/features/auth/components/MFASetupForm';

export const Route = createFileRoute('/login/mfa-setup')({
  component: Page,
  validateSearch: (s: Record<string, unknown>) => ({
    email: typeof s.email === 'string' ? s.email : undefined,
  }),
});

function Page() {
  const { email } = Route.useSearch();
  return (
    <AuthLayout brandPanel={<StaffAuthBrandPanel />} formSide="left">
      <MFASetupForm email={email ?? ''} />
    </AuthLayout>
  );
}
